import Glide from '@glidejs/glide';
class gallery{
	constructor() {
		this.glide = null;
	}
	modal(el) {
		const modal = document.querySelector(el.getAttribute('data-modal') || '#modal');
		if (modal) {
			Array.from(modal.querySelectorAll('.arrow')).forEach(arrow => {
				arrow.addEventListener('click', () => {
					this.glide.go(arrow.getAttribute('data-dir'));
				});
			});
			const triggers = Array.from(el.querySelectorAll('.gallery-image'));
			triggers.forEach(trigger => {
				trigger.addEventListener('click', (click) => {
					$(modal).on('shown.bs.modal', (e) => {
						$(modal).off('shown.bs.modal');
						this.glide = new Glide(
							modal.querySelector('.glide'), {
								startAt: parseInt(trigger.getAttribute('data-index'))
							}
						);
						this.glide.mount();
					});
					$(modal).on('hidden.bs.modal', (e) => {
						this.glide.destroy();
					});
					$(modal).modal();
				});
			});
		}
	}
}

window.app.add('gallery', new gallery());